import { deleteInitiativesUnsyncJiraSlice } from './@async/delete';
import { postInitiativesSyncJiraSlice } from './@async/post';

export const { requestPostInitiativesSyncJiraIssue, resetPostInitiativesSyncJiraIssue } = postInitiativesSyncJiraSlice.asyncActionCreators;
export const { requestDeleteInitiativesSyncJiraIssue, resetDeleteInitiativesSyncJiraIssue } = deleteInitiativesUnsyncJiraSlice.asyncActionCreators;
